import { VuexModule, Module, mutation, action, getter } from 'vuex-class-component';

@Module()
export default class NavigationStore extends VuexModule {
  @getter public loading: boolean = false;
  @getter public drawerOpen: boolean = false;
  @getter public snackbarMessage: string = "";
  @getter public snackbarVisible: boolean = false;
  @getter public snackbarColor: string = "primary";

  @mutation public setLoading(loading: boolean): void {
    this.loading = loading;
  }

  @mutation public setDrawerOpen(drawerOpen: boolean): void {
    this.drawerOpen = drawerOpen;
  }

  @mutation public setSnackbarMessage(snackbarMessage: string): void {
    this.snackbarMessage = snackbarMessage;
  }

  @mutation public setSnackbarVisible(snackbarVisible: boolean): void {
    this.snackbarVisible = snackbarVisible;
  }

  @mutation public setSnackbarColor(color: string): void {
    this.snackbarColor = color;
  }

  @action public async showSnackbar(params: { message: string; timeout: number; color: string }): Promise<any> {
    this.setSnackbarMessage(params.message);
    this.setSnackbarVisible(true);
    this.setSnackbarColor(params.color);
    setTimeout((): void => {
      if(this.snackbarMessage === params.message){
        this.setSnackbarVisible(false);
      }
    }, params.timeout);
  }
}